import { gql } from '@apollo/client';

export const leasingServiceTypeFragment = gql`
  fragment leasingServiceType on LeasingServiceType {
    id
    code
    name
    categoryId
    calculationClassId
    kindId
    calcTypeId
    amountTypeId
    percentOrValue
    defaultPercent
    defaultValue
    linkItemId
    linkItemName
    periodicity
    supplierId
    supplierName
    stVersion
    amountFormula
    interestAmountFormula
    vatAmountFormula
    initializationFormula
    defaultAmountFormula
    defaultPercentFormula
  }
`;

export const leasingServiceTypeLinkingFragment = gql`
  fragment leasingServiceTypeLinking on LeasingServiceTypeLinking {
    id
    typeId
    typeName
    sourceId
    sourceName
    destinationId
    destinationName
  }
`;
